export default "__VITE_ASSET__cf85b926__"